import React from 'react';
import { cn } from '../utils/cn';
const sizes = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
  xl: 'h-16 w-16 text-lg',
};
const statusDotSizes = {
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
  lg: 'h-3 w-3',
  xl: 'h-3.5 w-3.5',
};
const statusColors = {
  online: 'bg-success-500',
  offline: 'bg-neutral-400',
  busy: 'bg-danger-500',
  away: 'bg-warning-500',
};
function getInitials(name) {
  if (!name) return '?';
  return name
    .split(' ')
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}
export const Avatar = React.forwardRef(function Avatar(
  { src, alt, initials, size = 'md', status, className, ...props },
  ref,
) {
  const [imgError, setImgError] = React.useState(false);
  const showImage = src && !imgError;
  const displayInitials = initials || getInitials(alt);
  return (
    <div ref={ref} className={cn('relative inline-flex shrink-0', className)} {...props}>
      <div
        className={cn(
          'inline-flex items-center justify-center rounded-full bg-neutral-200 font-medium text-fg-secondary overflow-hidden',
          sizes[size],
        )}
      >
        {showImage ? (
          <img
            src={src}
            alt={alt || ''}
            className="h-full w-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : (
          <span aria-hidden="true">{displayInitials}</span>
        )}
      </div>
      {status && (
        <span
          className={cn(
            'absolute bottom-0 right-0 block rounded-full ring-2 ring-white',
            statusDotSizes[size],
            statusColors[status],
          )}
          aria-label={status}
        />
      )}
    </div>
  );
});
